import React from "react";
import api from "../setupAxios";
import { useDialog } from "../context/dialogContext";
import { fechaLarga, msgError, useListado } from "../utils";

// Lista de alumnos que han indicado "fuera de hora" (admisiones y admin). En admin se puede quitar.
export default function PanelFueraDeHora({ esAdmin = false }) {
  const { confirmarPeligro, avisar } = useDialog();
  const { datos, cargando, error, recargar } = useListado("/admisiones/fuera_de_hora", {});

  const quitar = async (a) => {
    if (!(await confirmarPeligro(`¿Quitar el «fuera de hora» de ${a.nombre}?`, { titulo: "Quitar fuera de hora", boton: "Quitar" }))) return;
    try { await api.delete(`/admin/fuera_de_hora/${a.id_user}`); recargar(); } catch (e) { avisar(msgError(e)); }
  };

  return (
    <div className="card">
      <div className="card-headrow">
        <h3>🕒 Fuera de hora <span className="count">{datos.length}</span></h3>
        <button className="btn" onClick={recargar}>🔄 Actualizar</button>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="tablewrap">
        <table className="ci-tabla t-fuera">
          <thead><tr><th>Alumno</th><th>Llega el</th><th>Hora</th><th>Medio</th><th>Último transporte desde</th><th>Comentario</th><th>Teléfono</th>{esAdmin && <th />}</tr></thead>
          <tbody>
            {cargando && datos.length === 0 && <tr><td colSpan={8} className="empty">Cargando…</td></tr>}
            {!cargando && datos.length === 0 && <tr><td colSpan={8} className="empty">Nadie ha indicado fuera de hora.</td></tr>}
            {datos.map((a) => (
              <tr key={a.id_user}>
                <td className="ci-nombre" title={a.email}>{a.nombre}</td>
                <td>{fechaLarga(a.fh_fecha)}</td>
                <td>{a.fh_hora || <span className="muted">—</span>}</td>
                <td>{a.fh_medio}</td>
                <td>{a.fh_origen}</td>
                <td className="ci-wrap">{a.fh_comentario}</td>
                <td className="mono">{a.telefono_wa || "—"}</td>
                {esAdmin && <td><button className="btn btn-mini btn-danger" onClick={() => quitar(a)}>Quitar</button></td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
